import type { GetDocumentAuditByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetDocumentAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDocumentAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetDocumentAuditByIdArgs = {
  id: string;
};

export const useGetDocumentAuditById = createQueryHook<
  UseGetDocumentAuditByIdArgs,
  GetDocumentAuditByIdResponseRow[],
  GetDocumentAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getDocumentAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ document_audit: data }),
  graphqlDocument: GetDocumentAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
